import { render, staticRenderFns } from "./typewriter.vue?vue&type=template&id=2078b296&scoped=true&"
import script from "./typewriter.vue?vue&type=script&lang=js&"
export * from "./typewriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078b296",
  null
  
)

export default component.exports